import React from 'react';

import KeyIcon from './KeyIcon';

export interface KeyItem {
  color: string;
  columnRef: string;
  columnVal: string;
  text: string;
}

interface KeyProps {
  keyItems: KeyItem[];
}

const Key = ({ keyItems }: KeyProps) => {
  return (
    <div className="mb-48">
      <figure className="m-0 flex flex-col items-start justify-center">
        <figcaption className="m-0 font-bold">Key:</figcaption>
        <ul className="m-0 mt-16 grid list-none grid-cols-min-1 gap-32 p-0 xs:grid-cols-min-2 sm:grid-cols-min-4">
          {keyItems.map((item) => (
            <li key={item.columnVal}>
              <div className="flex items-center gap-6">
                <KeyIcon color={item.color} />
                <span className="m-0 whitespace-nowrap text-body-sm">{item.text}</span>
              </div>
            </li>
          ))}
        </ul>
      </figure>
    </div>
  );
};

export default Key;
